export const DEFAULT_INDUSTRY = "roofer";
export const PREVIEW_DESIGNS = Object.freeze(["conversion", "premium", "trust"]);

const industryLabels = {
  roofer: "Roofer",
  plumber: "Plumber",
  electrician: "Electrician",
  hvac_contractor: "HVAC Contractor",
  general_contractor: "General Contractor",
  painter: "Painter",
  landscaper: "Landscaper",
  solar_energy_contractor: "Solar Contractor",
  concrete_contractors: "Concrete Contractors",
  fence_contractors: "Fence Contractors",
  high_ticket_tree_removal: "High Ticket Tree Removal",
  tree_services: "Tree Services",
  septic_drainage_excavation: "Septic, Drainage & Excavation"
};

const industryAliases = {
  roofing: DEFAULT_INDUSTRY,
  roofing_contractor: DEFAULT_INDUSTRY,
  roof_contractor: DEFAULT_INDUSTRY,
  roofers: DEFAULT_INDUSTRY,
  concrete_contractor: "concrete_contractors",
  fence_contractor: "fence_contractors",
  tree_service: "tree_services",
  septic_drainage_and_excavation: "septic_drainage_excavation"
};

export const PREVIEW_INDUSTRIES = Object.freeze([
  DEFAULT_INDUSTRY,
  "concrete_contractors",
  "fence_contractors",
  "high_ticket_tree_removal",
  "tree_services",
  "septic_drainage_excavation"
]);

const ignoredGoogleTypes = new Set(["contractor", "establishment", "point_of_interest", "service"]);

export function normalizeIndustry(value = "") {
  const normalized = String(value).trim().toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 80);
  return Object.hasOwn(industryAliases, normalized) ? industryAliases[normalized] : normalized;
}

export function industryForContact(contact = {}) {
  return normalizeIndustry(contact.industry) || DEFAULT_INDUSTRY;
}

export function previewIndustryForContact(contact = {}) {
  const industry = industryForContact(contact);
  return PREVIEW_INDUSTRIES.includes(industry) ? industry : null;
}

export function industryPreviewPath(industry = DEFAULT_INDUSTRY, design = "conversion") {
  const normalized = normalizeIndustry(industry) || DEFAULT_INDUSTRY;
  if (!PREVIEW_INDUSTRIES.includes(normalized) || !PREVIEW_DESIGNS.includes(design)) return "";
  return `${normalized === DEFAULT_INDUSTRY ? "" : `/industry/${normalized}`}/design/${design}`;
}

export function industryLabel(value = "") {
  const industry = normalizeIndustry(value);
  if (!industry) return "Ohne Branche";
  if (Object.hasOwn(industryLabels, industry)) return industryLabels[industry];
  return industry.split("_").filter(Boolean)
    .map((part) => part === "hvac" ? "HVAC" : `${part[0].toUpperCase()}${part.slice(1)}`)
    .join(" ");
}

export function industryFromGooglePlace(place = {}, fallback = "") {
  const googleTypes = [place.primaryType, ...(place.types || [])]
    .map(normalizeIndustry).filter((type) => type && !ignoredGoogleTypes.has(type));
  return googleTypes[0] || normalizeIndustry(fallback);
}

export function contactMatchesIndustry(contact, industry = "all") {
  return industry === "all" || industryForContact(contact) === normalizeIndustry(industry);
}

export function industryOptionsForContacts(contacts = []) {
  return [...new Set(contacts.map(industryForContact))]
    .map((value) => ({ value, label: industryLabel(value) }))
    .sort((left, right) => left.label.localeCompare(right.label, "de-DE"));
}

export const suggestedIndustries = Object.keys(industryLabels)
  .map((value) => ({ value, label: industryLabels[value] }));
